/**
 * Sage X3 Configuration Tooltips
 *
 * Organized by section with tooltips for each configuration field.
 * Usage: import { getSageX3Tooltip } from '../constants/tooltips/sageX3Tooltips';
 */

// Server Configuration tooltips
const SERVER_TOOLTIPS = {
    address: "The Sage X3 server hostname or IP address including the port number.\nExample: 192.168.1.100:8124",
    folder: "The Sage X3 folder name.\nThis must match the folder exactly as it is configured in Sage X3.",
    useHttps: "Enable this if your Sage X3 server requires a secure HTTPS connection.\nWhen disabled, standard HTTP will be used.",
};

// Connected Applications tooltips
const CONNECTED_APP_TOOLTIPS = {
    url: "The full API endpoint URL for the Sage X3 connected application.\nThis is the base URL used to communicate with the X3 REST API.",
    clientId: "The Client ID assigned to the connected application in Sage X3.\nThis can be found in Sage X3 under Administration > Connected Applications.\nThis value is case-sensitive and must match exactly.",
    clientSecret: "The Client Secret assigned to the connected application in Sage X3.\nThis can be found in Sage X3 under Administration > Connected Applications.\nThis value is case-sensitive and must match exactly.",
    user: "The Sage X3 user account for API authentication.\nThis is case-sensitive and must match exactly the user configured in the X3 connected application.",
    lifetime: "The authentication token validity period in seconds.\nThis must match the token lifetime configured in the Sage X3 connected application.\nDefault is 600 seconds (10 minutes).",
};

/**
 * Get a tooltip for a specific Sage X3 configuration field
 * @param {string} field - The field name (e.g., 'address', 'url', 'clientId')
 * @returns {string} The tooltip text
 */
export function getSageX3Tooltip(field) {
    if (SERVER_TOOLTIPS[field]) {
        return SERVER_TOOLTIPS[field];
    }

    if (CONNECTED_APP_TOOLTIPS[field]) {
        return CONNECTED_APP_TOOLTIPS[field];
    }

    return '';
}

/**
 * Get all Sage X3 tooltips merged into a single object
 * @returns {Object} Object containing all Sage X3 tooltips
 */
export function getAllSageX3Tooltips() {
    return {
        ...SERVER_TOOLTIPS,
        ...CONNECTED_APP_TOOLTIPS,
    };
}

// Export all tooltip objects for direct access if needed
export const SAGE_X3_TOOLTIPS = {
    server: SERVER_TOOLTIPS,
    connectedApp: CONNECTED_APP_TOOLTIPS,
};

export default SAGE_X3_TOOLTIPS;
